import React, { useEffect, useState } from "react";

const FeeReport = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [classInfo, setClassInfo] = useState("N/A");
  const [students, setStudents] = useState([]);

useEffect(() => {
  const fetchFeeReport = async () => {
    try {
      const teacher = JSON.parse(localStorage.getItem("teacher"));
      const sessionId = localStorage.getItem("currentSessionId");

      if (!teacher?.id || !sessionId) {
        setError("Teacher or session not found");
        return;
      }

      /* ---------- STEP 1: FETCH TEACHER ---------- */
      const teacherRes = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${teacher.id}?sessionId=${sessionId}`
      );

      if (!teacherRes.ok) throw new Error("Teacher fetch failed");

      const teacherData = await teacherRes.json();

      if (!teacherData.classIncharge) {
        setClassInfo("Not assigned");
        setStudents([]);
        return;
      }

      const [className, sectionName] = teacherData.classIncharge
        .split("-")
        .map(v => v.trim());

      setClassInfo(`${className} - ${sectionName}`);

      /* ---------- STEP 2: FETCH STUDENTS ---------- */
      const studentsRes = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents?class=${className}&section=${sectionName}&sessionId=${sessionId}`
      );

      if (!studentsRes.ok) throw new Error("Students fetch failed");

      const studentsList = await studentsRes.json();
      console.log("Students List:", studentsList);  // Debug: Check students data

      if (!Array.isArray(studentsList) || studentsList.length === 0) {
        setStudents([]);
        return;
      }

      /* ---------- STEP 3: FETCH LEDGER FOR EACH STUDENT ---------- */
      const ledgerPromises = studentsList.map(student => {
        if (!student._id) {
          console.warn(`Missing studentId for student: ${JSON.stringify(student)}`);
          return Promise.resolve(null); // Skip this student if no studentId
        }

        console.log("Fetching ledger for studentId:", student._id);  // Log the studentId

        return fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/ledgers/getLedgerByStudentId/${student._id}?sessionId=${sessionId}`
        ).then(res => res.json());
      });

      const ledgers = await Promise.all(ledgerPromises);

      console.log("Ledgers Data:", ledgers);  // Debug: Check ledgers data

      /* ---------- STEP 4: MERGE STUDENT + LEDGER ---------- */
    const finalData = studentsList.map(student => {
  const ledger = ledgers.find(l => l?.studentId === student._id);

  if (!ledger) {
    console.warn(`No ledger found for studentId: ${student._id}`);
    return {
      studentId: student._id,
      studentName: `${student.firstName} ${student.lastName}`,
      totalAmount: 0,
      paidAmount: 0,
      balance: 0
    }; // Default values if no ledger found
  }

  const totalAmount = ledger?.totalAmount || 0;
  const balance = ledger?.balance || 0;

  // Ensure paidAmount is never negative, convert to positive if negative
  let paidAmount = totalAmount - balance;
  paidAmount = Math.abs(paidAmount); // Convert to absolute value if negative

  return {
    studentId: student._id,
    studentName: `${student.firstName} ${student.lastName}`,
    totalAmount,
    paidAmount,
    balance
  };
});




      setStudents(finalData);
    } catch (err) {
      console.error(err);
      setError("Unable to load fee report");
    } finally {
      setLoading(false);
    }
  };

  fetchFeeReport();
}, []);




  if (loading) return <div className="p-6">Loading fee report...</div>;
  if (error)
    return <div className="p-6 text-center text-red-600">{error}</div>;

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">
        Fee Report ({classInfo})
      </h1>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-300">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-4 py-2">Student Name</th>
              <th className="border px-4 py-2">Total Amount</th>
              <th className="border px-4 py-2">Paid Amount</th>
              <th className="border px-4 py-2">Balance</th>
            </tr>
          </thead>

          <tbody className="text-center">
            {students.length > 0 ? (
              students.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="border px-4 py-2">
                    {item.studentName}
                  </td>
                  <td className="border px-4 py-2">
                    ₹{item.totalAmount}
                  </td>
                  <td className="border px-4 py-2 text-green-600">
                    ₹{item.paidAmount}
                  </td>
                  <td className="border px-4 py-2 text-red-600">
                    ₹{item.balance}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="py-4 text-gray-500">
                  No fee records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FeeReport;
